import React, {useContext, createContext, useCallback, ReactNode, useMemo} from 'react';
import {withTracking} from '@ezcater/tracking-react';
import eventMetadata from '../components/tracking/eventMetadata';
import {EventProps, TrackEvent} from '../constants/types';

type WrappedTrackEvent = (props: RequiredEventProps) => void;
export type RequiredEventProps = Omit<EventProps, keyof typeof eventMetadata['eventTracking']>;

export const TrackingHookContext = createContext<{trackEvent: TrackEvent}>({trackEvent: () => {}});

export const TrackingHookProvider = withTracking(
  ({trackEvent, children}: {trackEvent: TrackEvent; children: ReactNode}) => {
    const value = useMemo(() => ({trackEvent}), [trackEvent]);
    return <TrackingHookContext.Provider value={value}>{children}</TrackingHookContext.Provider>;
  }
);

export const useTracking = () => {
  const {trackEvent} = useContext(TrackingHookContext);

  const wrappedTrackEvent = useCallback<WrappedTrackEvent>(
    args => {
      trackEvent({
        ...eventMetadata.eventTracking,
        url: window?.location.href,
        ...args,
      });
    },
    [trackEvent]
  );

  return wrappedTrackEvent;
};
